import React from "react";
import { SourceFunction } from "./types";

interface SourceFunctionDetailsViewProps {
  selectedSourceFunction: SourceFunction;
}

export const SourceFunctionDetailsView: React.FC<SourceFunctionDetailsViewProps> = ({
  selectedSourceFunction,
}) => {
  return (
    <>
      :TODO: (jmtaber129): Build out page
      <br />
      Name: {selectedSourceFunction.name}
      <br />
      Function ID: {selectedSourceFunction.function_id}
      <br />
      Settings: {JSON.stringify(selectedSourceFunction.settings)}
    </>
  );
};
